// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/installations",
    name: "Installations List",
    meta: { title: "Montaže" },
    component: () => import(/* webpackChunkName: "Entities List" */ "@/Modules/Installation/Views/List"),
    children: [
      {
        path: "new",
        name: "New Installation",
        meta: { title: "Nova montaža" }
      },
      {
        path: "edit/:id",
        name: "Edit Installation (List)"
      }
    ]
    // beforeEnter: ifAuthenticated
  }
  // {
  //   path: "/installations/details/:id",
  //   name: "Installation Details",
  //   component: () => import(/* webpackChunkName: "Entities Details" */ "@/Modules/Installation/Views/Details"),
  //   children: [
  //     {
  //       path: "edit",
  //       name: "Edit Installation (Details)"
  //     }
  //   ]
  //   // beforeEnter: ifAuthenticated
  // }
]
